import { keyframes } from '@mui/material';

const spin = keyframes`from {transform: rotate(0deg)} to {transform: rotate(360deg)}`;

export { spin };
